import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpFromBracket } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import type { Maybe } from '@soundxyz/utils';
import type { ShareModalSource } from '@soundxyz/utils/analytics';
import { useModal } from '@context/modal';
import type { FeedPostActionsInfoFragment } from '@graphql/reactQuery';
import { trackClickEvent } from '@lib/analytics';
import { SharePostModal } from './SharePostModal';

export function SharePostButton({
  post,
  releasePostArtistTwitterHandle,
  sourceLocation,
}: {
  post: FeedPostActionsInfoFragment;
  releasePostArtistTwitterHandle: Maybe<string>;
  sourceLocation: ShareModalSource;
}) {
  const { openModal } = useModal();

  return (
    <div
      className="cursor-pointer rounded-md px-2 py-1 hover:bg-neutral100 active:scale-95"
      onClick={() => {
        trackClickEvent({
          event: 'Share Modal Opened',
          properties: {
            associationType: 'Post',
            associationId: post.id,
            sourceComponent: sourceLocation,
          },
        });
        openModal('SHARED_FEED_POST', {
          body: (
            <SharePostModal
              post={post}
              sourceLocation={sourceLocation}
              artistTwitterHandle={releasePostArtistTwitterHandle}
            />
          ),
        });
      }}
    >
      <FontAwesomeIcon icon={faArrowUpFromBracket} className="text-neutral500" fontSize={16} />
    </div>
  );
}
